import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { signOut } from "../slices/authSlice"; 
import { destroyProductData } from "../slices/productSlice"; 
import { all_routes } from "../Router/all_routes";
const route = all_routes;

export const InactivityRedirect = ({ 
  children, 
  inactivityTime = 3600000  // 1 heure en millisecondes 
}) => {
  const [lastActivityTime, setLastActivityTime] = useState(Date.now());
  const navigate = useNavigate();
  const dispatch = useDispatch(); 

  // Fonction pour gérer l'inactivité
  const handleInactivity = () => {
    if (Date.now() - lastActivityTime >= inactivityTime) {
      dispatch(destroyProductData());
      dispatch(signOut());

      navigate(route.signin);
    }
  };

  // Réinitialise le timer à chaque action utilisateur
  useEffect(() => {
    const resetTimer = () => setLastActivityTime(Date.now());

    // Liste des événements utilisateur à surveiller
    const events = ["click", "keydown", "mousemove", "scroll", "touchstart"];

    // Ajoute les écouteurs pour détecter l'activité
    events.forEach((event) => window.addEventListener(event, resetTimer));

    // Vérifie l'inactivité à intervalle régulier
    const interval = setInterval(handleInactivity, 1000);

    // Nettoyer les écouteurs et l'intervalle au démontage du composant
    return () => {
      events.forEach((event) => window.removeEventListener(event, resetTimer));
      clearInterval(interval);
    };
  }, [lastActivityTime, inactivityTime, navigate, dispatch]);

  return children; // Affiche les enfants si l'utilisateur est actif
};
